<template>
    <div class="famous-comment-list">
        <!-- 1. 命盘特点、性格、六亲关系及运势等整体分析 -->
        <div class="famous-pedia-cf-content">
            <div class="famous-pc-title" v-bind:class="{'famous-pc-title-border' : !commentTotalReplyData['all']}">
                <span class="famous-pcs-title">命盘特点、性格、六亲关系及运势等整体分析</span>
                <span class="famous-pcs-title-icon" @click.passive="clickBaseComment"><i class="iconfont icon-comment-1"></i></span>
            </div>
            <div class="famous-pc-content">
                <famous-comment-list-form
                    v-bind:liunianTitle="'命盘整体分析'"
                    v-bind:contentKey="'all'">
                </famous-comment-list-form>
            </div>
        </div>

        <!-- 2. 大运流年详细事迹 -->
        <div id="dayunliunian" class="famous-pedia-cf-content">
            <div class="famous-pc-title">
                <span class="famous-pcs-title">大运流年详细事迹</span>
            </div>
            <div class="famous-pedia-create-dyln-list">
                <div class="famous-pedia-create-dyln-item-box" v-for="dayunData of curPediaDayunLiunianList" v-bind:key="dayunData.name" >
                    <div class="famous-pedia-create-dyln-item" v-if="dayunData && dayunData.edited" v-bind:id="dayunData.name">
                        <!-- 大运信息部分 -->
                        <div class="famous-pc-dyln-dayun-info">
                            <div class="famous-pc-dyln-title-box" @click.stop="clickTitle('dayun' + dayunData.year)">
                                <span class="famous-pc-dyln-title"><span class="famous-pc-dyln-title-title">{{dayunData.ganzhi}}{{dayunData.before ? '' : '大运'}}</span>{{dayunData.year}}-{{dayunData.year+dayunData.liunian.length-1}}</span>
                            </div>
                        </div>
                        <!-- 流年信息部分 -->
                        <div class="famous-pc-dyln-liunian-list">
                            <div v-for="liunianData of dayunData.liunian" v-bind:key="liunianData.year" class="famous-pc-dyln-liunian-item-box">
                                <div v-if="liunianData && liunianData.edited" v-bind:id="liunianData.name" class="famous-pc-dyln-liunian-item">
                                    <div class="famous-pc-dyln-ln-title">
                                        <span @click.stop="clickTitle('liunian' + liunianData.year)">
                                            <span class="famous-pc-dyln-ln-title-title">{{liunianData.year}}</span>{{liunianData.ganzhi}}流年
                                            <span class="famous-pc-dyln-ln-title-year">虚岁:{{liunianData.age}}</span>
                                        </span>
                                        <span class="famous-pc-dyln-icon" @click.stop="clickComment(dayunData, liunianData)">
                                            <span class="famous-pc-dyln-icon-num">{{commentTotalReplyData['big_' + dayunData.key + '_' + liunianData.key] ? commentTotalReplyData['big_' + dayunData.key + '_' + liunianData.key].length : ''}}</span>
                                            <i class="iconfont icon-comment-1"></i>
                                        </span>
                                    </div>
                                    <div v-if="liunianData.content" class="famous-pc-dyln-ln-paragraph">
                                        <p class="famous-pc-dyln-ln-p" v-html="UTILS.getBreakLineByText(liunianData.content)"></p>
                                        <famous-comment-list-form
                                            v-bind:className="'famous-pc-comment-list-form-gray'"
                                            v-bind:liunianTitle="liunianData.year+liunianData.ganzhi+'流年'"
                                            v-bind:contentKey="'big_' + dayunData.key + '_' + liunianData.key">
                                        </famous-comment-list-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 最后一行 -->
            <div class="famous-pc-dyln-liunian-last-box"><div class="famous-pc-dyln-liunian-last"></div></div>
        </div>
    </div>
</template>
<script>
import FamousCommentListForm from './FamousCommentListForm.vue'
import { UTILS } from '../../modules/utils'
import { FAMOUS_DOM } from '../../modules/dom'
export default {
    name: 'FamousCommentList',
    components: { FamousCommentListForm },
    computed: {
        curPediaDayunLiunianList() {
            return this.$store.state.famouspedia.curPediaDayunLiunianList;
        },
        commentTotalReplyData() {
            return this.$store.state.famouspediacomment.commentTotalReplyData;
        }
    },
    data() {
        return {
            UTILS: UTILS,
        }
    },
    methods: {
        clickBaseComment() {
            var me = this,
                key = 'all',
                curId = this.$store.state.famouspedia.curPediaBaziId;
            this.$store.dispatch('famouspediacomment/setCommentFormData', {
                formData: {
                    bid: curId,
                    f_type: key,
                    parentsid: 0,
                    touid: 0
                }
            })
            this.$store.dispatch('famouspediacomment/initCommentAllListData', {
                key: key,
                cb: function() {
                    setTimeout(() => {
                        FAMOUS_DOM.updateFamousFormStyle();
                        FAMOUS_DOM.bindFamousFormScrollEvent(false);
                        me.$bus.emit('focusFamousBottomBar');
                        window.scrollTo(0, 0);
                    }, 20);
                }
            });
        },
        clickComment(dayunData, liunianData) {
            var me = this,
                key = 'big_' + dayunData.key + '_' + liunianData.key,
                curId = this.$store.state.famouspedia.curPediaBaziId;
            this.$store.dispatch('famouspediacomment/setCommentFormData', {
                formData: {
                    bid: curId,
                    f_type: key,
                    parentsid: 0,
                    touid: 0
                }
            })
            this.$store.dispatch('famouspediacomment/initCommentAllListData', {
                key: key,
                cb: function() {
                    setTimeout(() => {
                        FAMOUS_DOM.updateFamousFormStyle();
                        FAMOUS_DOM.bindFamousFormScrollEvent(false);
                        me.$bus.emit('focusFamousBottomBar');
                        window.scrollTo(0, 0);

                        // 设置迷你命盘数据
                        var itemId = me.$store.state.famouspediacomment.commentAllYear;
                        me.$bus.emit('triggerTitleLinkItem', itemId)
                    }, 20);
                }
            });
        },
        clickTitle(itemId) {
            this.$bus.emit('triggerTitleLinkItem', itemId)
        }
    }
}
</script>